module.exports = __webpack_public_path__ + "img/mayplaylist.9d678393.png";